import styled from 'styled-components';

interface StyledSearchProps {
    $disabled?: boolean;
}

export const StyledSearch = styled.div<StyledSearchProps>`
    pointer-events: ${({ $disabled }) => $disabled && 'none'};
`;
